import {FormControl, FormControlLabel, Grid, RadioGroup, Typography} from "@mui/material";
import {useFormContext} from "react-hook-form";
import {useTranslation} from "react-i18next";
import {FormAlertModel} from "../../../api/types/alert";
import FormTimePicker from "../../../common/form-fields/FormTimePicker";
import {pink} from "@mui/material/colors";
import Radio from "@mui/material/Radio";

type Props = {
    readonly: boolean;
}
const DailyScheduler = ({readonly}: Props) => {
    // Use Translation
    const {t} = useTranslation(["translation", "pricing"]);

    //USE FORM CONTEXT
    const {register, watch} = useFormContext<FormAlertModel>();

    return (
        <Grid container spacing={2} p={2} alignItems="start">
            <Grid container spacing={2} p={2} alignItems="start">
                <Typography variant="h6" width={"100%"} pl={2} mt={4}>
                    {t("pricing:alert.labels.dailySchedule")}
                </Typography>
                <Grid item xs={12}>
                    <FormControl>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="row-radio-buttons-group"
                            defaultValue={t(
                                "pricing:alert.labels.everyWeekDay"
                            )}>
                            <FormControlLabel
                                value={t(
                                    "pricing:alert.labels.everyWeekDay"
                                )}
                                control={
                                    <Radio
                                        sx={{
                                            color: pink[800],
                                            "&.Mui-checked": {
                                                color: pink[600]
                                            }
                                        }}
                                    />
                                }
                                label={t(
                                    "pricing:alert.labels.everyWeekDay"
                                )}
                            />
                        </RadioGroup>
                    </FormControl>
                </Grid>
                {/* START TIME */}
                <Grid item xs={12} md={3}>
                    <FormTimePicker
                        {...register("crons.startTime")}
                        label="START TIME*"
                        readOnly={readonly}
                    />
                </Grid>
                {/* ADD TIME */}
                <Grid item xs={12} md={3}>
                    <FormTimePicker
                        {...register("crons.addTime")}
                        label="ADD TIME"
                        readOnly={readonly || !watch("crons.startTime")}
                    />
                </Grid>
            </Grid>
        </Grid>
    );
};

export default DailyScheduler;
